"use client";

import {
  PARTNER_REVEAL_MOTION_CLASS,
  PARTNER_REVEAL_STAGGER_MS,
  partnerColumnRevealStyle,
} from "@/components/partners/partner-column-reveal";
import { PartnerSiteLink } from "@/components/partners/partner-site-link";
import { ActionButton } from "@/components/ui/action-button";
import { useScrollAnimate } from "@/hooks/use-scroll-animate";
import Image from "next/image";

/** Set page for the Story Time Chess games. */
export const STORY_TIME_CHESS_GAMES_HREF = "/pages/story-time-chess";
export const STORY_TIME_CHESS_SITE_HREF =
  "https://storytimechess.com/?utm_source=playmath&utm_medium=partner&utm_campaign=partners_page";

export function StoryTimeChessSection() {
  const textAnimate = useScrollAnimate();
  const imageAnimate = useScrollAnimate();

  return (
    <section
      className="py-12 text-white md:py-16 lg:py-20"
      style={{ backgroundColor: "#6A469D" }}
      data-testid="story-time-chess-section"
    >
      <div className="mx-auto max-w-[1024px] px-3 sm:px-4">
        <div className="flex flex-col items-center gap-8 md:flex-row md:gap-12">
          <div
            ref={textAnimate.ref}
            className={`order-1 w-full text-center md:order-2 md:w-2/5 md:text-left ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(textAnimate.isVisible, "right", {
              delayMs: PARTNER_REVEAL_STAGGER_MS,
            })}
          >
            <div className="mb-4">
              <Image
                src="/images/marketing/partners/storyTimeChess/logo.webp"
                alt="Story Time Chess logo"
                width={600}
                height={398}
                className="inline-block h-16 w-auto md:h-20"
              />
            </div>
            <p className="mb-6 text-pretty text-base text-white md:text-lg">
              Kids as young as three learn chess through imaginative stories that turn each piece
              into a character. Along the way they build critical thinking, confidence, and
              emotional intelligence.
            </p>
            <ActionButton href={STORY_TIME_CHESS_GAMES_HREF} variant="white">
              Play chess!
            </ActionButton>
            <div className="mt-6">
              <ActionButton href={STORY_TIME_CHESS_SITE_HREF}>Learn more</ActionButton>
            </div>
            <PartnerSiteLink href={STORY_TIME_CHESS_SITE_HREF} tone="dark" />
          </div>

          <div
            ref={imageAnimate.ref}
            className={`order-2 w-full md:order-1 md:w-3/5 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(imageAnimate.isVisible, "left")}
          >
            <Image
              src="/images/marketing/partners/storyTimeChess/hero.webp"
              alt="Adult and child playing Story Time Chess"
              width={900}
              height={507}
              className="h-auto w-full rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
